/* eslint-disable @next/next/no-img-element */
import React, { useContext } from 'react';
import { CLEARPAY_BUTTON_IMG_TEXT } from '../../../brands/default/content/components/checkout';
import { CLEARPAY_BUTTON_IMG } from '../../../config/constants/images';
import ThemeContext from '../../../providers/ThemeProvider';

const ClearpayButton = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <img
        alt={CLEARPAY_BUTTON_IMG_TEXT}
        className="clearpay"
        src={CLEARPAY_BUTTON_IMG}
      />
      <span className="sr-only">Clearpay</span>
      <style jsx>{`
        .clearpay {
          width: 95%;
          padding: 5%;
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .clearpay {
            width: 100%;
            padding: 6%;
          }
        }
      `}</style>
    </>
  );
};

export default ClearpayButton;
